import React from 'react'
import {ApolloProvider} from '@apollo/client'
import Head from 'next/head'
import {GlobalStyles} from 'twin.macro'
import {useApollo} from '../apollo/client'
import Banner from '../components/Banner'
import SiteLayout from '../components/SiteLayout'
import {useRouter} from 'next/router'
import '../styles/globals.css'
import '../lib/fontawesome'
const App = ({Component, pageProps}) => {
  const router = useRouter()
  const apolloClient = useApollo(pageProps)
  const getLayout =
    Component.getLayout ||
    (page => <SiteLayout>{page}</SiteLayout>)

  return (
    <>
      <Head>
        <title>Dangle It Order Lookup</title>
        <meta name="theme-color" content="#adfff7"/>
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
        />
      </Head>
      <GlobalStyles />
      <ApolloProvider client={apolloClient}>
        {router.asPath !== '/' && <Banner />}
        {getLayout(<Component {...pageProps} />)}
      </ApolloProvider>
    </>
  )
}

export default App
